import { NodeListItem } from '../../model/node-list-item';
import { CccAdapterTransitionTargetItem } from '../../services/climate-engine/ccc-adapter/ccc-adapter-transition-target-item';
import { DEFAULT_TRAJECTORY_FUNCTION_TYPE } from '../../app.constants';

export function nodeListItemToCccAdapterTransitionTargetItem(
  nodeListItem: NodeListItem
): CccAdapterTransitionTargetItem {
  return {
    targetLevel: nodeListItem.nodeProperties.transitionTargetData.transitionProperties.targetLevel,
    transitionElement: nodeListItem.nodeProperties.transitionTargetData.transitionTargetProperties.transitionElement,
    trajectoryFunctionType:
      nodeListItem.nodeProperties.transitionTargetData.transitionProperties.transitionPath?.type ||
      DEFAULT_TRAJECTORY_FUNCTION_TYPE,
    manualPath: nodeListItem.nodeProperties.transitionTargetData.transitionProperties.transitionPath?.manualPath,
    nodeId: nodeListItem.id,
  };
}
